import type { BlokProps } from "@trydig/storyblok";
import type { LinkStoryblok } from "~/generated/sb/blok-types";
import { Link } from "~/i18n/routing";
import { getLink } from "~/lib/storyblok/getLink";

export const LinkBlok = ({ blok }: BlokProps<LinkStoryblok>) => {
	const linkUrl = getLink(blok.link);
	const linkText = blok.text;

	const blankProps = blok.targetBlank ? { target: "_blank", rel: "noopener noreferrer" } : {};

	if (linkUrl)
		return (
			<Link {...blankProps} href={linkUrl}>
				{linkText}
			</Link>
		);
	throw new Error("No url was found on this link");
};
